export enum WorkshopVisibilityEnum {
  MALE = "Men",
  FEMALE = "Women",
  CHILDREN = "Children",
  ALL = "All",
}
